import { cn } from '@/shared/lib/utils';
import { Fragment, type ReactNode } from 'react';

/**
 * 실적_대시보드 Type=kpi (495:7000) — 라벨 13 Medium · 값 24 Bold · 보조 13 Medium
 * Type=detail (523:1008) — 라벨 · 이름 16 SemiBold · 값 24 Bold · 보조
 */
export const KpiItem = ({
  label,
  name,
  value,
  valueClassName,
  sub,
  subClassName,
}: {
  label: string;
  /** detail 형: 값 위 병의원 이름 */
  name?: ReactNode;
  value: ReactNode;
  valueClassName?: string;
  sub?: ReactNode;
  subClassName?: string;
}) => (
  <div className="flex min-w-0 flex-1 flex-col gap-2">
    <p className="text-body-13-r font-medium text-fg-tertiary">{label}</p>
    <div className="flex min-w-0 flex-col gap-1">
      <div className="flex min-w-0 flex-col">
        {name && (
          <p className="truncate text-body-16-sb text-fg-primary">{name}</p>
        )}
        <p
          className={cn(
            'truncate text-heading-24-b text-fg-primary',
            valueClassName,
          )}
        >
          {value}
        </p>
      </div>
      {sub && (
        <p
          className={cn(
            'truncate text-body-13-r font-medium text-fg-tertiary',
            subClassName,
          )}
        >
          {sub}
        </p>
      )}
    </div>
  </div>
);

/** row/KPI — 항목 사이 세로 구분선(1px line-grey), 간격 24 · 안쪽 24 */
export const KpiRow = ({
  items,
  className,
}: {
  items: ReactNode[];
  className?: string;
}) => (
  <div
    className={cn(
      'grid grid-cols-2 gap-6 p-6 lg:flex lg:items-stretch',
      className,
    )}
  >
    {items.map((item, i) => (
      <Fragment key={i}>
        {i > 0 && (
          <div
            aria-hidden
            className="hidden w-px shrink-0 self-stretch bg-line-grey lg:block"
          />
        )}
        {item}
      </Fragment>
    ))}
  </div>
);
